import { AbstractControl, ValidationErrors } from '@angular/forms';
import { AbstractRule } from './abstract-rule';
import { ValidationResultFactory } from './validation-result-factory';

export class UppercaseCharacterRule extends AbstractRule {
  validate(control: AbstractControl): ValidationErrors | null {
    const resultFactory = new ValidationResultFactory(
      'UppercaseCharacterRule',
      this.validationService
    );

    if (control.value) {
      if (control.value < 'A' || control.value > 'Z') {
        resultFactory.addResult('NotUppercaseCharacter');
      }
    }

    return resultFactory.validationErrors;
  }
}
